/** До стольких знаков половина адреса не рвётся: такая встаёт в строку в самой узкой колонке, где выводится адрес
 *  (строка создания на главной, 320 px с полосой прокрутки, около 216 px). */
const WHOLE_PART_CHARS = 24;

/** Половина адреса. Короткая — без переносов внутри: браузер рвал строку на дефисе («qa-» / «d1@example.com»,
 *  R2-04). Длинная — переносится по своим местам и по `[overflow-wrap:anywhere]` обёртки: целиком она бы не встала. */
function Part({ text }: { text: string }) {
  return text.length <= WHOLE_PART_CHARS ? <span className="whitespace-nowrap">{text}</span> : <>{text}</>;
}

/** Адрес с местом переноса после «@»: на узком экране он делится на «имя@» и «домен», а не посреди
 *  слова. Обёртке нужен `[overflow-wrap:anywhere]` — на случай, если и половина не влезет. */
export function EmailText({ email }: { email: string }) {
  const at = email.indexOf('@');
  if (at < 0) return <>{email}</>;
  return (
    <>
      <Part text={email.slice(0, at + 1)} />
      <wbr />
      <Part text={email.slice(at + 1)} />
    </>
  );
}
